import script from "./meeting-extra-settings.vue?vue&type=script&setup=true&lang=ts"
export * from "./meeting-extra-settings.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__